import { Component } from '@angular/core';
import { PwaInstallService } from './pwa-install.service'; // adatta path

@Component({
    selector: 'app-install-prompt',
    standalone: true,
    template: `
    @if(isAvailable) {
        <button (click)="install()"
                class="pwa-install-btn">
            Installa BLC App
        </button>
    }
  `,
    styles: [`
    .pwa-install-btn {
      position: fixed;
      bottom: 20px;
      right: 20px;
      background: #1976d2;
      color: white;
      border: none;
      padding: 12px 20px;
      border-radius: 50px;
      font-weight: bold;
      box-shadow: 0 4px 12px rgba(0,0,0,0.3);
      z-index: 10000;
      cursor: pointer;
    }
    .pwa-install-btn:hover {
      background: #1565c0;
    }
  `]
})
export class InstallPromptComponent {
    isAvailable = false;

    constructor(private pwaService: PwaInstallService) {
        this.pwaService.promptAvailable$.subscribe(available => {
            this.isAvailable = !!available;
        });
    }

    async install() {
        await this.pwaService.showPrompt();
    }
}
